export const COMPANY_NAME = "NPR Digital Partner";

export const PREVIOUS_VERSION = "3.6.10";
export const CURRENT_VERSION = "3.6.11";

export let isServiceDown = false;

export const setIsServiceDown = (isDown) => {
  isServiceDown = isDown;
};
